import { ValidationCallback } from "validation/validate";

export type RequestToMentorRawFromApi = {
	hostUid: string;
	guestUid: string;
	isAccepted: boolean;
	isRejected: boolean;
	displayNameGuest: string;
	displayNameHost: string;
	privateMessageContents?: string;
	privateMessageDatesentUTC?: string;
	privateMessageId?: string;
};

export const flagValidationErrorsInRequestToMentorRawFromApi: ValidationCallback<
	RequestToMentorRawFromApi
> = (input, { checkField }) => {
	checkField("hostUid", { type: "string" });
	checkField("guestUid", { type: "string" });
	checkField("isAccepted", { type: "boolean" });
	checkField("isRejected", { type: "boolean" });
	checkField("displayNameGuest", { type: "string" });
	checkField("displayNameHost", { type: "string" });

	checkField("privateMessageContents", { type: "string", isRequired: false });
	checkField("privateMessageDatesentUTC", {
		type: "string",
		isRequired: false
	});
	checkField("privateMessageId", { type: "string", isRequired: false });
};
